import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { WorkingHoursResponse } from '../../../../../../api/types/lecturers/working-hours/working-hours.type';

export const getWorkingHoursOperations = async (
  userId: number,
  startDate: Date,
  endDate: Date,
  setLoading: (loading: boolean) => any,
  setData: (data: WorkingHoursResponse[]) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getWorkingHours(userId, startDate, endDate);
    setData(res.data.body);
    setLoading(false);
  } catch (e) {
    setLoading(false);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
  }
};
